import {BASE_URL} from 'appConstants';

import {get} from 'sdk';

export const fetchLocations = () => {
  let url = `${BASE_URL}/v1/locations/`;
  return get(url);
};

export const fetchLocation = ({locationRef}) => {
  let url = `${BASE_URL}/v1/locations/${locationRef}/`;
  return get(url);
};

export const exportEmergencyContactsCsv = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/emergency/contacts/export-csv/`;
  return get(url);
};
